import React, { useState, useEffect } from "react";
import "./PostSingleView.css";
import { Link } from "react-router-dom";
import { Feed, Divider, Icon } from "semantic-ui-react";
import Post from "./Post/Post";
import { useAuthContext } from "../../Hooks/useAuthContext";
import { usePostsContext } from "../../Hooks/usePostsContext";
import { isMobile } from "react-device-detect";
import noAvatar from "../../assets/img/noAvatar.png";
import { useParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import MetaTags from "../../components/MetaTags/MetaTags";
import { useMetaData } from "../../Context/MetaDataContext";
import ListContainer from "../ListContainer/ListContainer";
import ListContainerRight from "../ListContainerRight/ListContainerRight";
import { plainText } from "../../podcast/catalog";
const PostSingleView = () => {
  const { post, dispatch } = usePostsContext();
  const [error, setError] = useState(null);
  const { user } = useAuthContext();
  const [relatedPosts, setRelatedPosts] = useState([]);
  const [randomPosts, setRandomPosts] = useState([]);
  const { metaData } = useMetaData();
  const { id } = useParams();
  const isPodcastPost = Boolean(post?.audioUrl && ["Audio", "Podcast"].includes(post.category));
useEffect(() => {
  const fetchPostAndRelated = async () => {
    try {
      const response = await fetch(`/api/posts/${id}`);
      if (response.ok) {
        const postData = await response.json();
        dispatch({ type: "FETCH_SINGLE_POST", payload: postData });

        // Fetch related posts
        const relatedRes = await fetch(`/api/posts/related/${id}`);
        if (relatedRes.ok) {
          const relatedJson = await relatedRes.json();
          setRelatedPosts(relatedJson);
        }

        // ✅ Fetch random posts
        const randomRes = await fetch(`/api/posts/random`);
        if (randomRes.ok) {
          const randomJson = await randomRes.json();
          setRandomPosts(randomJson);
        }
      }
    } catch (error) {
      setError(error.message);
    }
  };

  fetchPostAndRelated();
}, [dispatch, id]);
  // GET THE POSTS DATA FROM BACKEND
  // useEffect(
  //   () => {
  //     const fetchData = async () => {
  //       try {
  //         const response = await fetch(`/api/posts/${id}`);
  //         if (response.ok) {
  //           const json = await response.json();
  //           dispatch({ type: "FETCH_SINGLE_POST", payload: json });
  //         }
  //       } catch (error) {
  //         setError(error.message);
  //       }
  //     };
  //     fetchData();
  //   },
  //   [dispatch],
  //   id
  // );
  // LIKE HANDLER
  const handleLike = async (eventId) => {
    if (!user || !user.user || !user.user.username) {
      return;
    }

    const response = await fetch("/api/posts/" + eventId + "/like", {
      method: "PUT",
      body: JSON.stringify({ username: user.user.username }),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${user.token}`,
      },
    });

    if (response.ok) {
      //   dispatch({
      //     type: "POST_LIKE",
      //     payload: { id: eventId, user: user.user.username },
      //   });
      window.location.href = `/p/${eventId}`;
    } else {
      console.error("Error liking post");
    }
  };
  // DISLIKE HANDLER
  const handleDisLike = async (eventId) => {
    if (!user) {
      return;
    }
    const response = await fetch("/api/posts/" + eventId + "/disLike", {
      method: "PUT",
      body: JSON.stringify({ username: user.user.username }),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${user.token}`,
      },
    });

    if (response.ok) {
      //   dispatch({
      //     type: "POST_DISLIKE",
      //     payload: { id: eventId, user: user.user.username },
      //   });
      window.location.href = `/p/${eventId}`;
    } else {
      console.error("error");
    }
  };
  // handle Update
  const handleUpdate = async (eventId, post) => {
    if (!user) {
      return;
    }
    // dispatch({
    //   type: "POST_UPDATE",
    //   payload: { id: eventId, data: post },
    // });
    window.location.href = `/p/${eventId}`;
  };
  // HANDLE DELETE
  const handleDelete = async (eventId) => {
    try {
      if (!user) {
        throw new Error("Please login");
      }
      const response = await fetch(`/api/posts/${eventId}`, {
        method: "DELETE",
        body: JSON.stringify({
          userId: user.user._id,
          userRole: user.user.role,
          isAdmin: user.user.isAdmin,
        }),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user.token}`,
        },
      });
      const json = await response.json();
      if (response.ok) {
        // dispatch({ type: "DELETE_POST", payload: json });
        window.location.href = `/p/${eventId}`;
      } else {
        throw new Error("Failed to delete post");
      }
    } catch (error) {
      console.error(error.message);
    }
  };

  return (
    <>
      <MetaTags
        title={post?.topic || "We Win Together"}
        description={isPodcastPost ? plainText(post.description) || post.topic :
          post?.topic ||
          "Explore We Win Together for live setups, breaking news, and classes"
        }
        image={
          (isPodcastPost && post?.thumbnailUrl) || post?.tradingviewImage ||
          "https://media.discordapp.net/attachments/1299207836156563516/1361447172905636031/logoSmartTrading_copy.jpg?ex=67fec9fc&is=67fd787c&hm=81b61bfb1439e43ee828a9fb8ae7371d4ea0bd3df0bd253ce1505b0f97067b7f&=&format=webp&width=700&height=700"
        }
        author={post?.username || "WWT"}
      />
      {post ? (
        <div className={`Home${isPodcastPost ? " is-podcast-detail" : ""}`}>
          {!isMobile && !isPodcastPost && <ListContainer />}
          <div className={`PostSingleView${isPodcastPost ? " is-podcast-detail" : ""}`}>
            {error && <div>{error}</div>}
            {isPodcastPost && <article className="podcast-detail-hero">
              <div className="podcast-detail-hero__cover">
                {post.thumbnailUrl ? <img src={post.thumbnailUrl} alt={`${post.topic || "Podcast"} cover`} /> : <Icon name="microphone" />}
              </div>
              <div className="podcast-detail-hero__content">
                <span className="podcast-detail-hero__eyebrow"><Icon name="headphones" /> Podcast episode</span>
                <h1>{post.topic || "Podcast episode"}</h1>
                <div className="podcast-detail-hero__meta">
                  <span><Icon name="user outline" /> {post.username || "We Win Together"}</span>
                  {post.createdAt && <span><Icon name="calendar outline" /> {new Date(post.createdAt).toLocaleDateString()}</span>}
                  <span><Icon name="play circle outline" /> {(Number(post.viewer) || 0).toLocaleString()} plays</span>
                  {post.subCategory && <span>{post.subCategory}</span>}
                </div>
                {post.description && <p className="podcast-detail-hero__description">{plainText(post.description)}</p>}
                <audio src={post.audioUrl} controls preload="metadata" controlsList="nodownload" aria-label={`Play ${post.topic || "podcast episode"}`} />
              </div>
            </article>}
            {isPodcastPost && post.body && <section className="podcast-detail-transcript">
              <div className="podcast-detail-transcript__heading">
                <span className="podcast-detail-transcript__eyebrow">Episode notes</span>
                <h2>Transcript</h2>
              </div>
              <p>{plainText(post.body)}</p>
            </section>}
            <Feed size="large">
              <Post
                post={post}
                key={post._id}
                isPodcastDetail={isPodcastPost}
                onUpdate={handleUpdate}
                onDelete={handleDelete}
                onLike={handleLike}
                onDisLike={handleDisLike}
              />
              {relatedPosts.length > 0 && (
                <section className={isPodcastPost ? "podcast-detail-related" : "post-single-related"}>
                  <h2>{isPodcastPost ? "More episodes" : `🔥 ${metaData.MENU.RELATE}`}</h2>
                  <ul>
                    {relatedPosts.map((rel) => (
                      <li key={rel._id} style={{ marginBottom: "0.5rem" }}>
                        <Link to={`/p/${rel._id}`} className="post-title-link">
                          {rel.topic}{isPodcastPost && <Icon name="arrow right" />}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </section>
              )}
              {!isPodcastPost && randomPosts.length > 0 && (
                <div>
                  <h4 style={{ marginBottom: "1rem", color: "#2185d0" }}>
                    🎲 {metaData.MENU.RANDOM}
                  </h4>
                  <ul style={{ paddingLeft: "1rem" }}>
                    {randomPosts.map((rel) => (
                      <li key={rel._id} style={{ marginBottom: "0.5rem" }}>
                        <Link to={`/p/${rel._id}`} className="post-title-link">
                          {rel.topic}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </Feed>
          </div>
          {!isMobile && !isPodcastPost && <ListContainerRight />}
        </div>
      ) : (
        <h1>YOU NEED TO LOGIN TO VIEW THIS POST</h1>
      )}

      {/* {user &&
      (user.user.role === 1 ||
        user.user.role === 2 ||
        user.user.role === 3 ||
        user.user.role === 4 ||
        user.user.role === 5 ||
        user.user.role === 6 ||
        user.user.role === 10) &&
      post ? (
        <div className="Posts">
          {error && <div>{error}</div>}
          <Divider horizontal>
            <Link to="/hub">
              <span className="hub">WE WIN TOGETHER</span>
            </Link>
          </Divider>
          <Feed size="large">
            <Post
              post={post}
              key={post._id}
              onUpdate={handleUpdate}
              onDelete={handleDelete}
              onLike={handleLike}
              onDisLike={handleDisLike}
            />
          </Feed>
        </div>
      ) : (
        <h1>YOU NEED TO LOGIN TO VIEW THIS POST</h1>
      )} */}
    </>
  );
};

export default PostSingleView;
